import PropTypes from "prop-types";

export default PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    value: PropTypes.any,
});
